import { HostListener, Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { BreakpointEnum } from '../enums/breakpoint.enum';

@Injectable({
  providedIn: 'root',
})
export class HandleScreenService {
  private screenWidthSubject: BehaviorSubject<number> =
    new BehaviorSubject<number>(window.innerWidth);

  updateScreenWidth(): void {
    this.screenWidthSubject.next(window.innerWidth);
  }

  isMobile(): boolean {
    return this.screenWidthSubject.value <= BreakpointEnum.MOBILE_SIZE;
  }

  @HostListener('window:resize', ['$event'])
  onWindowResize() {
    this.updateScreenWidth();
  }
}
